import logoT from '../assets/logo/logo-t-1.png'

export const NavbarLogo = () => {
    return (
        <>
            <div className="flex items-center gap-3">
                <img src={logoT} alt="" className="h-[2.4rem] object-cover" />
                <span className="text-[#E2E2E4] font-spaceGrotesk text-[18px] font-normal mt-[5px]">thoby.za</span>
            </div>
        </>
    )
}